module.exports = __webpack_public_path__ + "static/media/ask-question-bonus.5bdb0223.png";